import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampeonatosService } from '../services/campeonatosService';
import { IconTrophy } from '../components/icons';
import './ListaCampeonatos.css';

const BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace('/api', '');

function ListaCampeonatos() {
  const navigate = useNavigate();
  const [campeonatos, setCampeonatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const camps = await CampeonatosService.listar();
      setCampeonatos(camps);
    } catch (err) {
      setError('Não foi possível carregar os campeonatos.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return '—';
    // new Date(string) interpreta "2026-09-19" como meia-noite UTC; em fuso
    // atrás de UTC (Brasil) isso exibe o dia anterior. Construindo a partir
    // dos componentes Y-M-D como data local, evita o efeito de virar o dia.
    const [ano, mes, dia] = d.slice(0, 10).split('-');
    return new Date(ano, mes - 1, dia).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getStatusStyle = (status) => {
    const map = {
      'INSCRIÇÕES ABERTAS': { bg: '#D1FAE5', color: '#065F46', dot: '#10B981' },
      'INSCRIÇÕES ENCERRADAS': { bg: '#FEE2E2', color: '#991B1B', dot: '#EF4444' },
      'EM ANDAMENTO': { bg: '#FEF3C7', color: '#92400E', dot: '#F59E0B' },
      'FINALIZADO': { bg: '#F3F4F6', color: '#374151', dot: '#6B7280' },
      'CANCELADO': { bg: '#FEE2E2', color: '#7F1D1D', dot: '#DC2626' },
    };
    return map[status] || map['INSCRIÇÕES ABERTAS'];
  };

  if (loading) return <div className="campeonatos-loading">Carregando campeonatos...</div>;

  return (
    <div className="campeonatos-container">
      <div className="campeonatos-header">
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><IconTrophy /> Campeonatos</h1>
          <p>Gerencie todos os eventos e campeonatos do sistema.</p>
        </div>
        <button className="btn-primary" onClick={() => navigate('/campeonatos/novo')}>
          + Criar Novo Campeonato
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="campeonatos-grid">
        {campeonatos.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">🏆</span>
            <h3>Nenhum campeonato cadastrado</h3>
            <p>Clique no botão acima para criar o seu primeiro evento.</p>
          </div>
        ) : (
          campeonatos.map(camp => {
            const st = getStatusStyle(camp.status);
            return (
              <div
                key={camp.id}
                className="campeonato-card"
                onClick={() => navigate(`/campeonatos/${camp.id}`)}
                style={{ cursor: 'pointer' }}
              >
                {/* Banner / Capa */}
                <div
                  className="camp-cover event-tile-header"
                  style={{ backgroundImage: camp.capa_url ? `url("${BASE_URL}${camp.capa_url}")` : 'none' }}
                >
                  {!camp.capa_url && <span>Sem Capa</span>}
                  <div className="camp-status-badge" style={{ background: st.dot }}>
                    <span className="camp-status-dot" />
                    {camp.status}
                  </div>
                </div>

                {/* Info */}
                <div className="camp-info">
                  <h3>{camp.nome}</h3>
                  <div className="camp-meta">
                    <span className="camp-meta-item">📅 {formatDate(camp.data_inicio)} → {formatDate(camp.data_fim)}</span>
                    <span className="camp-meta-item">📍 {camp.local}{camp.cidade ? ` — ${camp.cidade}/${camp.estado}` : ''}</span>
                    {camp.tabela_peso_nome && (
                      <span className="camp-meta-item">⚖️ {camp.tabela_peso_nome}</span>
                    )}
                    <span className="camp-meta-item">
                      ✅ {camp.inscritos_total || 0} inscrito{camp.inscritos_total === '1' ? '' : 's'}
                      {parseInt(camp.inscritos_pendentes, 10) > 0 && (
                        <strong style={{ color: '#B45309' }}> · {camp.inscritos_pendentes} aguardando pagamento</strong>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default ListaCampeonatos;
